require('./bootstrap');
import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/draggable';

window.$ = window.jQuery = $;
require('select2/dist/js/select2.min');
